import Grid from '@mui/material/Grid';
import { useTheme } from "@mui/material";


export default function HighDrugs() {

const theme = useTheme();

return (
<>

{theme.palette.mode === "light" ? (

        <Grid container sx={{mb:2, p:1, pl:2, display:'flex', justifyContent:'center', bgcolor: 'grey.C600', borderRadius: '10px'}}>  
 
                        <Grid item xs={3} >   </Grid>
                        <Grid item xs={2} >   </Grid>
                        <Grid item xs={1} > </Grid>
                        <Grid item xs={6} ></Grid> 
                        
                </Grid>
        ) : (

                <Grid container sx={{mb:2, p:1, pl:2, display:'flex', justifyContent:'center', bgcolor: 'secondary.C800', borderRadius: '10px'}}>  
 
                        <Grid item xs={3} >   </Grid>
                        <Grid item xs={2} >   </Grid>
                        <Grid item xs={1} > </Grid>
                        <Grid item xs={6} ></Grid> 
                        
                </Grid>
)}
</>

)};
